import styled from 'styled-components';
import { ONBOARDING_CLOSE_COMMENT_MODE_ANCHOR } from 'collaboration-sidebar/features/deepCommenting/constants/deepCommentingOnboarding';
const OnboardingCloseAnchor = styled.div.attrs({
  'data-onboarding': ONBOARDING_CLOSE_COMMENT_MODE_ANCHOR
}).withConfig({
  displayName: "OnboardingCloseAnchor",
  componentId: "sc-6driw-0"
})(["position:relative;top:65px;left:120px;width:1px;height:1px;"]);
export default OnboardingCloseAnchor;